import { apiFetch } from './index';

/**
 * Obtener todas las herramientas
 */
export const getHerramientas = async () => {
    try {
        const response = await apiFetch('/Herramienta', { method: 'GET' });
        return response;
    } catch (error) {
        console.error('Error al obtener herramientas:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener una herramienta por ID
 * @param {number} id - ID de la herramienta
 */
export const getHerramientaById = async (id) => {
    try {
        const response = await apiFetch(`/Herramienta/${id}`, { method: 'GET' });
        return response;
    } catch (error) {
        console.error(`Error al obtener herramienta ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Crear una nueva herramienta
 * @param {Object} data - Datos de la herramienta
 * @param {string} data.codigo - Código de la herramienta
 * @param {string} data.nombre - Nombre de la herramienta
 * @param {string} data.descripcion - Descripción
 * @param {string} data.marca - Marca
 * @param {number} data.stock - Cantidad inicial en stock
 * @param {string} data.estado - Estado (Activo, Inactivo, Mantenimiento)
 */
export const createHerramienta = async (data) => {
    try {
        const response = await apiFetch('/Herramienta', {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return response;
    } catch (error) {
        console.error('Error al crear herramienta:', error);
        return { success: false, error: error.message };
    }
};

/**
 * Actualizar una herramienta
 * @param {number} id - ID de la herramienta
 * @param {Object} data - Datos a actualizar
 */
export const updateHerramienta = async (id, data) => {
    try {
        const response = await apiFetch(`/Herramienta/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return response;
    } catch (error) {
        console.error(`Error al actualizar herramienta ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Eliminar una herramienta
 * @param {number} id - ID de la herramienta
 */
export const deleteHerramienta = async (id) => {
    try {
        const response = await apiFetch(`/Herramienta/${id}`, {
            method: 'DELETE'
        });
        return response;
    } catch (error) {
        console.error(`Error al eliminar herramienta ID ${id}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener herramientas por estado
 * @param {string} estado - Estado de la herramienta
 */
export const getHerramientasByEstado = async (estado) => {
    try {
        const response = await apiFetch(`/Herramienta/estado/${estado}`, { method: 'GET' });
        return response;
    } catch (error) {
        console.error(`Error al obtener herramientas por estado ${estado}:`, error);
        return { success: false, error: error.message };
    }
};

/**
 * Obtener herramientas con bajo stock
 * @param {number} limite - Límite de stock (default: 5)
 */
export const getHerramientasBajoStock = async (limite = 5) => {
    try {
        const response = await apiFetch(`/Herramienta/bajo-stock/${limite}`, { method: 'GET' });
        return response;
    } catch (error) {
        console.error(`Error al obtener herramientas bajo stock:`, error);
        return { success: false, error: error.message };
    }
};

export default {
    getHerramientas,
    getHerramientaById,
    createHerramienta,
    updateHerramienta,
    deleteHerramienta,
    getHerramientasByEstado,
    getHerramientasBajoStock
};